import { render, staticRenderFns } from "./ClosedTable.vue?vue&type=template&id=2848045e&scoped=true&"
import script from "./ClosedTable.vue?vue&type=script&lang=js&"
export * from "./ClosedTable.vue?vue&type=script&lang=js&"
import style0 from "./ClosedTable.vue?vue&type=style&index=0&id=2848045e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2848045e",
  null
  
)

export default component.exports